/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import StepWizard from 'react-step-wizard'
import { Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'

import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import ElegibilidadSec1View from './ElegibilidadSec1'
import ElegibilidadSec2View from './ElegibilidadSec2'
import ElegibilidadSec3View from './ElegibilidadSec3'
import ElegibilidadSec4View from './ElegibilidadSec4'
import ElegibilidadSec5View from './ElegibilidadSec5'
import ElegibilidadSec6View from './ElegibilidadSec6'
// import { ModalStatusForm } from '../Modals/ModalStatusForm'
import { useFormElegibilidad } from '../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../context/EligibilityContext'
import {
  getElegibilityForm,
  getManagementPlanMitigationsIsTherePlanMitigations,
  getReportWithoutPlan,
  getReportWithPlan,
} from '../../../../services/Elegibilidad/get'
import { LoadingButton } from '@mui/lab'
import ROUTES from '../../../../routers/routes'

const ElegibilidadFormView = ({ idForm, goToStep }) => {
  const { EligibilityForm, setEligibilityForm } = useFormElegibilidad()
  const [state, dispatch] = useEligibility()
  const history = useHistory()
  const [sec, setSec] = useState(1)

  // const [openEdit, setOpenEdit] = useState(false)
  const [loadingData, setLoadingData] = useState(true)
  const [loadingPDF, setLoadingPDF] = useState(false)

  const next2 = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    setSec(2)
  }
  const next1 = () => {
    dispatch({ type: 'SET_STATE', payload: 1 })
    setSec(1)
  }
  const next3 = () => {
    dispatch({ type: 'SET_STATE', payload: 3 })
    setSec(3)
  }
  const next4 = () => {
    dispatch({ type: 'SET_STATE', payload: 4 })
    setSec(4)
  }
  const next5 = () => {
    dispatch({ type: 'SET_STATE', payload: 5 })
    setSec(5)
  }
  const next6 = () => {
    dispatch({ type: 'SET_STATE', payload: 6 })
    setSec(6)
  }

  useEffect(() => {
    let mounted = true
    getElegibilityForm(idForm)
      .then((result) => {
        if (result.Success) {
          if (mounted) {
            setEligibilityForm(result.Data)
            setLoadingData(() => false)
          }
        }
      })
      .catch((result) => {
        // TODO: Mostrar mensaje diciendo que hay error y volver a inicio
        console.log(result)
      })

    return () => {
      mounted = false
    }
  }, [])

  const cancelForm = () => {
    history.goBack()
  }

  const getIfiPlan = async () => {
    try {
      setLoadingPDF(true)
      const response = await getManagementPlanMitigationsIsTherePlanMitigations(
        EligibilityForm.IdElegibilityAnswer,
      )
      if (response.Success) {
        if (response.Data === false) {
          getPDFWithoutPlan()
        } else if (response.Data === true) {
          getPDFWithPlan()
        }
      } else {
        setLoadingPDF(false)
        throw Error('Problema al obtener el plan de accion')
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const getPDFWithPlan = async () => {
    try {
      const response = await getReportWithPlan(
        EligibilityForm.IdElegibilityAnswer,
      )
      if (response.Success) {
        setLoadingPDF(false)
        const byteCharacters = atob(response.Data.Report)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const filename = `Formulario  #${
          EligibilityForm.ENumber ? EligibilityForm.ENumber : ''
        }`
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      }
    } catch (error) {
      console.log(error)
      setLoadingPDF(false)
    }
  }

  const getPDFWithoutPlan = async () => {
    try {
      const response = await getReportWithoutPlan(
        EligibilityForm.IdElegibilityAnswer,
      )
      if (response.Success) {
        setLoadingPDF(false)
        const byteCharacters = atob(response.Data.Report)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const filename = `Formulario  #${
          EligibilityForm.ENumber ? EligibilityForm.ENumber : ''
        }`
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      }
    } catch (error) {
      console.log(error)
      setLoadingPDF(false)
    }
  }

  return (
    <>
      <div
        id="wizard-form"
        style={{
          overflow: 'hidden',
          backgroundColor: 'white',
          boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
        }}
      >
        <div style={{ marginBottom: '48px' }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '16px' }}
          >
            <Grid item md={12} sm={12} xs={12}>
              <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                }}
              >
                <label className="formTitle">
                  Formulario Elegibilidad de Inversiones para Financiamiento
                </label>
                <span className="formIDDetail">
                  Código Formulario:#{' '}
                  {EligibilityForm.ENumber ? EligibilityForm.ENumber : ''}
                </span>
              </div>
            </Grid>
          </Grid>

          <Grid
            container
            md={12}
            sm={12}
            spacing={1}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Grid item>
              <div
                data-tip
                data-for="exitPop"
                onClick={() => cancelForm()}
                style={{
                  backgroundColor: 'red',
                  color: '#fff',
                  width: '60px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
                  <span>Regresar</span>
                </ReactTooltip>
              </div>
            </Grid>

            <Grid item>
              <div onClick={() => getIfiPlan()} data-tip data-for="savePop">
                {/* <FileDownloadIcon style={{ transform: 'scaleX(-1)' }} /> */}

                <LoadingButton
                  loadingPosition="start"
                  variant="contained"
                  startIcon={
                    <FileDownloadIcon style={{ transform: 'scaleX(-1)' }} />
                  }
                  loading={loadingPDF}
                  style={{
                    backgroundColor: '#5cb85c',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                  }}
                ></LoadingButton>
              </div>
              <ReactTooltip
                id="savePop"
                effect="solid"
                backgroundColor="#5cb85c"
              >
                <span>Descargar</span>
              </ReactTooltip>
            </Grid>
          </Grid>
        </div>
        {!loadingData && EligibilityForm !== '' ? (
          <>
            <Grid
              container
              spacing={1}
              style={{ marginTop: '18px', marginBottom: '36px' }}
            >
              <Grid
                item
                xs={12}
                sm={2}
                md={2}
                className={`${
                  state.step === 1
                    ? `stepper__title-active`
                    : `stepper__title-inactive`
                }`}
                onClick={() => next1()}
              >
                <label style={{ cursor: 'pointer' }}>SECCIÓN 1</label>
              </Grid>
              <Grid
                item
                xs={12}
                sm={2}
                md={2}
                className={`${
                  state.step === 2
                    ? `stepper__title-active`
                    : `stepper__title-inactive`
                }`}
                onClick={() => next2()}
              >
                <label style={{ cursor: 'pointer' }}>SECCIÓN 2</label>
              </Grid>
              <Grid
                item
                xs={12}
                sm={2}
                md={2}
                className={`${
                  state.step === 3
                    ? `stepper__title-active`
                    : `stepper__title-inactive`
                }`}
                onClick={() => next3()}
              >
                <label style={{ cursor: 'pointer' }}> SECCIÓN 3</label>
              </Grid>
              <Grid
                item
                xs={12}
                sm={2}
                md={2}
                className={`${
                  state.step === 4
                    ? `stepper__title-active`
                    : `stepper__title-inactive`
                }`}
                onClick={() => next4()}
              >
                <label style={{ cursor: 'pointer' }}>SECCIÓN 4</label>
              </Grid>
              <Grid
                item
                xs={12}
                sm={2}
                md={2}
                className={`${
                  state.step === 5
                    ? `stepper__title-active`
                    : `stepper__title-inactive`
                }`}
                onClick={() => next5()}
              >
                <label style={{ cursor: 'pointer' }}>SECCIÓN 5</label>
              </Grid>
              <Grid
                item
                xs={12}
                sm={2}
                md={2}
                className={`${
                  state.step === 6
                    ? `stepper__title-active`
                    : `stepper__title-inactive`
                }`}
                onClick={() => next6()}
              >
                <label style={{ cursor: 'pointer' }}> SECCIÓN 6</label>
              </Grid>
            </Grid>

            {sec === 1 ? (
              <StepWizard initialStep={1}>
                <ElegibilidadSec1View />
                <ElegibilidadSec2View />
                <ElegibilidadSec3View />
                <ElegibilidadSec4View />
                <ElegibilidadSec5View />
                <ElegibilidadSec6View />
              </StepWizard>
            ) : (
              ''
            )}
            {sec === 2 ? (
              <StepWizard initialStep={2}>
                <ElegibilidadSec1View />
                <ElegibilidadSec2View />
                <ElegibilidadSec3View />
                <ElegibilidadSec4View />
                <ElegibilidadSec5View />
                <ElegibilidadSec6View />
              </StepWizard>
            ) : (
              ''
            )}
            {sec === 3 ? (
              <StepWizard initialStep={3}>
                <ElegibilidadSec1View />
                <ElegibilidadSec2View />
                <ElegibilidadSec3View />
                <ElegibilidadSec4View />
                <ElegibilidadSec5View />
                <ElegibilidadSec6View />
              </StepWizard>
            ) : (
              ''
            )}
            {sec === 4 ? (
              <StepWizard initialStep={4}>
                <ElegibilidadSec1View />
                <ElegibilidadSec2View />
                <ElegibilidadSec3View />
                <ElegibilidadSec4View />
                <ElegibilidadSec5View />
                <ElegibilidadSec6View />
              </StepWizard>
            ) : (
              ''
            )}
            {sec === 5 ? (
              <StepWizard initialStep={5}>
                <ElegibilidadSec1View />
                <ElegibilidadSec2View />
                <ElegibilidadSec3View />
                <ElegibilidadSec4View />
                <ElegibilidadSec5View />
                <ElegibilidadSec6View />
              </StepWizard>
            ) : (
              ''
            )}
            {sec === 6 ? (
              <StepWizard initialStep={6}>
                <ElegibilidadSec1View />
                <ElegibilidadSec2View />
                <ElegibilidadSec3View />
                <ElegibilidadSec4View />
                <ElegibilidadSec5View />
                <ElegibilidadSec6View />
              </StepWizard>
            ) : (
              ''
            )}
          </>
        ) : (
          <Box className="loadingEditContainer">
            <Grid className="loadingSub">
              <CircularProgress />
            </Grid>
          </Box>
        )}
      </div>
    </>
  )
}

export default ElegibilidadFormView
